import { BCMSRecord, BCMSStateManagerCRUD, useBCMSContext } from "@bcm-dev/bcms-vite";
import Util from "classes/Util";
import { getTransactionAccordionConfig } from "components/custom-ui/CustomTransactionAccordion";
import AccountDetailsPage, { getDefaultPageUI } from "components/pages/AccountDetailsPage";
import Classes, { Account } from "model";
import { useEffect } from "react";

export default function CaptureAccountsViewCheckImage(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);
    const { branding} = context.state;
    const showConsumerAccounts = Account.hasConsumerAccounts(branding);
    const { key, value } = getTransactionAccordionConfig(showConsumerAccounts ? "2" : "64");

    const ui = BCMSStateManagerCRUD.init(getDefaultPageUI())
    .update([ key ], { ...value, accordionActive: true, showChecks: true })
    .submit();

    useEffect(() => {
        Util.replaceDOMDataPointValues(branding);
    });

    return <AccountDetailsPage ui={ ui } />
}